import { render } from "./CommentButton.vue?vue&type=template&id=00f27d4a"
import script from "./CommentButton.vue?vue&type=script&lang=js"
export * from "./CommentButton.vue?vue&type=script&lang=js"

import "./CommentButton.vue?vue&type=style&index=0&id=00f27d4a&lang=css"
script.render = render

export default script